import { TransitionStatus } from 'react-transition-group';
import styled from 'styled-components';

const transitionStyles = {
  entering: 0.5,
  entered: 1,
  exiting: 0.5,
  exited: 0,
  unmounted: 0,
} as Record<TransitionStatus, number>;

interface AnimationProps {
  $state: TransitionStatus;
  $duration?: number;
  $timingFunction?: string;
}

const defaultDuration = 150;
const defaultTimingFunction = 'cubic-bezier(0.55, 0.085, 0.68, 0.53)';

const getOpacity = (state: TransitionStatus) => transitionStyles[state] ?? 0;

export const Animation = styled.div<AnimationProps>`
  opacity: ${({ $state }) => getOpacity($state)};
  transition-property: opacity;
  transition-duration: ${({ $duration }) => $duration ?? defaultDuration}ms;
  transition-timing-function: ${({ $timingFunction }) => $timingFunction ?? defaultTimingFunction};
`;
